import html2canvas from 'html2canvas'

export const takeScreenshotAsImage = async () => {
  const element = document.body
  const canvas = await html2canvas(element)
  return canvas?.toDataURL('image/png')
}
